import { apiConnection } from "@/services/api-connection";
import router from "@/router";
import { mainStore } from "@/main";
import { storageManager } from "@/services/storage/storage-manager";
import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { useUserStore } from "@/store/user/user";

const URL_INFOS = "/app/user/me";
const URL_ONE_USER = "/app/user/info/";
// const URL_USER = "/ufauser/";
const URL_CHECK = "/app/user/verify-user";
const URL_POST = "/app/user/put/";
const URL_POST_PICTURE = "/post-picture";
const URL_PERMISSIONS_ADMIN = "/app/user/permissions";
const URL_PERMISSIONS_STUDEA_MANAGER = "/app/studea-manager/permissions";

class UserManager {
  PROFILE_APPRENTICE = 1;
  PROFILE_TUTOR = 2;
  PROFILE_APPRENTICE_MASTER = 3;
  PROFILE_STUDEA_MANAGER = 4;

  loadUserInfos() {
    return apiConnection
      .get(URL_INFOS, {}, true)
      .then((response) => response)
      .catch((res) => {
        if (!res.success) {
          userManager.logout(true);
          router.push({ name: "Login" });
        }
      });
  }

  loadUser(id) {
    return apiConnection.get(URL_ONE_USER + id).then((response) => response);
  }

  loadPermissions(trainingCourse = null, forceStudeaManager = false) {
    const user = useUserStore().user;
    if (trainingCourse || (!trainingCourse && forceStudeaManager)) {
      return apiConnection
        .get(URL_PERMISSIONS_STUDEA_MANAGER + (trainingCourse ? "/" + trainingCourse : ""))
        .then((response) => response);
    } else if (user.target === "admin") {
      return apiConnection.get(URL_PERMISSIONS_ADMIN).then((response) => response);
    }
    return new Promise((resolve) => resolve(false));
  }

  checkUsername = (username) => {
    return apiConnection
      .get(
        URL_CHECK,
        {
          email: username,
        },
        false,
      )
      .then((response) => response);
  };

  logout(withReferer = false) {
    storageManager.clear();
    mainStore.setAppLoading(true);
    mainStore.initStore();

    let query = {};
    if (withReferer) {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.delete("magic-link");
      if (url.pathname !== "/login") {
        query = { referer: url.pathname + params };
      }
    }

    setTimeout(function () {
      router.push({ name: "Login", query: query });
      mainStore.setAppLoading(false);
      if (Object.keys(query).length && !withReferer) {
        notificationManager.showAlert(
          "info",
          i18n.global.t("reconnect_error"),
          i18n.global.t("reconnect_error_message"),
          true,
        );
      }
    }, 300);
  }

  putUserInfos(id, datas) {
    return apiConnection.put(URL_POST + id, datas).then((response) => response);
  }

  postUserPicture(data, folder) {
    return apiConnection
      .post(
        URL_POST_PICTURE,
        {
          data: data.data,
          filename: data.fileName,
          type: data.type,
          folder: folder,
        },
        true,
      )
      .then((response) => response);
  }

  getProfileKey(profile) {
    let key;
    switch (profile) {
      case this.PROFILE_APPRENTICE:
        key = "apprentice";
        break;
      case this.PROFILE_TUTOR:
        key = "tutor";
        break;
      case this.PROFILE_APPRENTICE_MASTER:
        key = "apprenticeMaster";
        break;
      case this.PROFILE_STUDEA_MANAGER:
        key = "studeaManager";
        break;
    }
    return key;
  }

  getProfileByName(profileName) {
    let key;
    switch (profileName) {
      case "apprentices":
        key = this.PROFILE_APPRENTICE;
        break;
      case "tutors":
        key = this.PROFILE_TUTOR;
        break;
      case "apprenticeMasters":
        key = this.PROFILE_APPRENTICE_MASTER;
        break;
      case "studeaManagers":
        key = this.PROFILE_STUDEA_MANAGER;
        break;
    }
    return key;
  }

  checkUserProfile(user, triad) {
    if (triad.apprentice && user.id === triad.apprentice.id) {
      return this.PROFILE_APPRENTICE;
    } else if (triad.tutor && user.id === triad.tutor.id) {
      return this.PROFILE_TUTOR;
    } else if (triad.apprenticeMaster && user.id === triad.apprenticeMaster.id) {
      return this.PROFILE_APPRENTICE_MASTER;
    } else {
      return this.PROFILE_STUDEA_MANAGER;
    }
  }

  findUserType(userType, triad) {
    if (triad.triadUsers) {
      return triad.triadUsers.filter((triadUser) => triadUser.userType === userType);
    }
  }

  regenerateUserName($this, urlCall) {
    const param = {
      lastName: $this.tabs[0]?.models?.lastName?.vars?.value,
      firstName: $this.tabs[0]?.models?.firstName?.vars?.value,
    };
    $this.loading = true;
    return apiConnection.post(urlCall, param).then((data) => {
      notificationManager.showNotification("success", i18n.global.t("regenerate_succes"));
      if ($this.tabs[0].models["username"]?.vars?.value) {
        $this.tabs[0].models["username"].vars.value = data;
      }
      $this.loading = false;
    });
  }

  async activateAccount() {
    return await apiConnection.get("/app/user/form/first-login");
  }

  async postUserFirstConnection(data) {
    return await apiConnection.post("/app/user/post/first-login", data);
  }
}

export const userManager = new UserManager();
